import { ErrorStateMatcher } from '@angular/material/core';
import {
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
  FormControl,
  FormGroupDirective,
  NgForm,
} from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';
// import { parsePhoneNumberFromString, parse } from 'libphonenumber-js';

const phoneNumberUtil = PhoneNumberUtil.getInstance();

// tslint:disable-next-line: no-unnecessary-initializer
export function PhoneNumberValidator(regionCode: string = undefined): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let validNumber = false;
    try {
      const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(control.value, regionCode);
      validNumber = phoneNumberUtil.isValidNumber(phoneNumber);
    } catch (e) {}

    return validNumber ? null : { wrongPhoneNumber: { value: control.value } };
  };
}

// form validator
export class PhoneNumberEStateMatcher implements ErrorStateMatcher {
  callingCodeFieldName = 'callingCode';
  phoneFieldName = 'phone';

  constructor(option?: { callingCodeFieldName?: string; phoneFieldName?: string }) {
    if (option && option.callingCodeFieldName) {
      this.callingCodeFieldName = option.callingCodeFieldName;
    }
    if (option && option.phoneFieldName) {
      this.phoneFieldName = option.phoneFieldName;
    }
  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (!control) {
      return false;
    }
    return (
      (control.errors && control.touched) ||
      (control.parent.get(this.callingCodeFieldName).value &&
        control.parent.get(this.phoneFieldName).value &&
        control.dirty)
    );
  }
}

export function ValidatorPhoneNumber(option?: {
  formName?: string;
  callingCodeFieldName?: string;
  phoneFieldName?: string;
}): ValidatorFn {
  let formName = '';
  let callingCodeFieldName = 'callingCode';
  let phoneFieldName = 'phone';

  if (option && option.formName) {
    formName = option.formName;
  }
  if (option && option.callingCodeFieldName) {
    callingCodeFieldName = option.callingCodeFieldName;
  }
  if (option && option.phoneFieldName) {
    phoneFieldName = option.phoneFieldName;
  }

  return (control: FormGroup): ValidationErrors | null => {
    let validNumber = false;
    try {
      const callingCode = control && control.get(callingCodeFieldName).value;
      const phone = control && control.get(phoneFieldName).value;

      if (!phone) {
        return null;
      }

      const fullPhone = '+' + callingCode + phone;
      const phoneNumber = phoneNumberUtil.parse(fullPhone);
      validNumber = phoneNumberUtil.isValidNumber(phoneNumber);
    } catch (e) {
      // console.log(e);
    }

    if (validNumber) {
      return null;
    } else {
      const validatorJson = {};
      if (formName) {
        validatorJson[`${formName}.${phoneFieldName}`] = 'wrongPhoneNumber';
      } else {
        validatorJson[phoneFieldName] = 'wrongPhoneNumber';
      }
      return validatorJson;
    }
  };
}
